import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

/**
 * Flow-agnostic OAuth popup relay (agent-sessions design § OAuth popup flow):
 * hand `code` + `state` back to the opener via postMessage and close. All
 * flow-specific behaviour (state verification, which backend endpoint gets
 * the code) lives in the opener, so any future first-party Connect popup
 * reuses this route unchanged. Deliberately renders nothing user-visible —
 * the popup closes as soon as the message is handed off.
 */
function ConnectCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    if (code && state && window.opener) {
      (window.opener as Window).postMessage({ code, state }, window.location.origin);
      // Give the opener a beat to receive the message — closing synchronously
      // can flip the closed flag before the message event is delivered.
      const closeTimer = setTimeout(() => window.close(), 100);
      return () => clearTimeout(closeTimer);
    }
    window.close();
  }, []);
  return null;
}

export const Route = createFileRoute('/connect/callback')({
  component: ConnectCallback,
});
